"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.natalie.description': '友好、聪明的美国女性，完美适合叙述。',
};
